import { render } from "./App.vue?vue&type=template&id=49c7b4ae"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=49c7b4ae&lang=css"

import exportComponent from "/home/soder/git/pokedex/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__